import AddModule from "../components/addModule";
import ListModules from "../components/listModules";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import useCustomState from "../hooks/State";

const Modules = (props) => {
  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const navigations = [
      { name: "مدیریت ماژول های هوشمند", path: "/admin/modules" },
    ];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
  }, []);

  return (
    <>
      <AddModule />
      <ListModules />
    </>
  );
};

export default Modules;
